<template>
  <PageBase title="Introductie ambitiethema's" description="" :valid="valid" @show-error="showError" :show-right-button="true" :show-left-button="true">
    <div class="flex flex-col gap-3 text-justify xl:mr-15">
      <div class="text-sm">Binnen het generieke Programma van Eisen is nadrukkelijk aandacht voor belangrijke thema's zoals onderhoudskosten, losmaakbaarheid, duurzaamheid en binnenklimaat. Het doel is om meer integrale sturing op deze onderwerpen te realiseren bij de ontwikkeling van onderwijshuisvesting. Voor de verschillende indicatoren zijn realistische, haalbare waarden vastgesteld die toepasbaar zijn op de projecten van morgen. Deze set vormt het basisniveau van het PvE.</div>

      <div class="text-sm">Naast dit basisniveau zijn er aanvullende ambitiethema's opgenomen. De initiatiefnemer kan ervoor kiezen om voor één of meerdere thema's de waarde van een indicator - en daarmee de ambitie - te verhogen. Deze hogere ambitie vraagt om een grotere investering, maar vertaalt zich in gunstigere exploitatiekosten, een duurzamer gebouw en een toekomstbestendiger schoolgebouw.</div>

      <div class="text-sm">Bij voorkeur vindt de dialoog over deze ambitiethema's tussen het schoolbestuur en de gemeente plaats in de initiatieffase. Een adviseur van RuimteOK of een huisvestingsadviseur kan hierbij ondersteuning bieden met inhoudelijke expertise. Het STIKO-model en het TCO-rekenmodel van POHV maken de effecten van de gekozen ambities inzichtelijk, zowel op investerings- als exploitatiekosten.</div>
      <div class="text-sm">Op de volgende pagina worden de verschillende thema's toegelicht en kunt u aangeven of u deze wilt toevoegen aan uw Programma van Eisen.</div>
    </div>
  </PageBase>
</template>

<script setup lang="ts">
import PageBase from '@/views/pages/PageBase.vue';
//import { useRegistrationStore } from '@/stores/registration'
import { ref } from 'vue';

//const store = useRegistrationStore()
const errorsShown = ref(false)
const valid = ref(true)

function showError() {
  errorsShown.value = true
}
</script>
